export interface BrandMemberRoleProps {
  roleKey: string;
  roleName: string;
}

export interface BrandMemberProps {
  userId: number;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  avatar: string | null;
  roles: BrandMemberRoleProps[];
  isDeleted: boolean;
}

export class BrandMember {
  private readonly _userId: number;
  private readonly _firstName: string;
  private readonly _lastName: string;
  private readonly _fullName: string;
  private readonly _email: string;
  private readonly _avatar: string | null;
  private readonly _roles: BrandMemberRoleProps[];
  private readonly _isDeleted: boolean;

  constructor(props: BrandMemberProps) {
    this._userId = props.userId;
    this._firstName = props.firstName;
    this._lastName = props.lastName;
    this._fullName = props.fullName;
    this._email = props.email;
    this._avatar = props.avatar;
    this._roles = props.roles;
    this._isDeleted = props.isDeleted;
  }

  get userId(): number {
    return this._userId;
  }

  get firstName(): string {
    return this._firstName;
  }

  get lastName(): string {
    return this._lastName;
  }

  get fullName(): string {
    return this._fullName;
  }

  get email(): string {
    return this._email;
  }

  get avatar(): string | null {
    return this._avatar;
  }

  get roles(): BrandMemberRoleProps[] {
    if (this._roles && this._roles.length > 0) {
      return this._roles;
    }
    return [];
  }

  get isDeleted(): boolean {
    return this._isDeleted;
  }

  static from(props: BrandMemberProps): BrandMember {
    return new BrandMember(props);
  }
}
